module.exports = " <div class=work-frame :style=workFrameStyle _v-5152af3b=\"\"> <div class=image-container _v-5152af3b=\"\"> <a v-if=link :href=link target=_blank _v-5152af3b=\"\"> <div class=image :style=imageStyle _v-5152af3b=\"\"></div> </a> <div v-if=!link class=image :style=imageStyle _v-5152af3b=\"\"></div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5152af3b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkFrame.vue
 ** module id = 32
 ** module chunks = 1
 **/